module.exports = __webpack_public_path__ + "img/m_profession.df26668b.png";